import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import appimage from "../../images/representations-user-experience-interface-design_23-2150104494.jpg"
import { Link } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const App_Services = () => {
  React.useEffect(() => {
    gsap.fromTo(
      ".app-services",
      { y:50, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        scrollTrigger: {
          trigger: ".app-services",
          start: "top 30%",
          end: "bottom 10%",
          toggleActions: "play none none reverse",
        },
      }
    );
  }, []);

  return (
    <>
      {/* Upar Services Section - White Background */}
      <Container fluid className="services-section py-5">
        <Row className="align-items-center">

          {/* Image Section */}
          <Col lg={6} md={12} sm={12} className="text-center services-image">
            <div className="image-wrapper" style={{ marginRight: "17px" }}>
              <img 
                src={appimage}
                alt="App Development"  
                className="img-fluid rounded shadow"  
              />
            </div>
          </Col>

          {/* Text Content Section */}
          <Col lg={6} md={12} sm={12} className="mb-4 mb-lg-0">
            <h2 className="title">App Development</h2>
            <p className="description">
              We create high-quality mobile and web applications tailored to your business needs.
              From simple utility apps to complex platforms, our team ensures your app is user-friendly, scalable, and performance-optimized.
            </p>

            <h3 className="offer-title">What we offer:</h3>
            <ul className="services-list">
              <li>
                <FaCheckCircle className="icon" /> Custom mobile & web app design (iOS, Android, Web)
              </li>
              <li>
                <FaCheckCircle className="icon" /> Backend development & API integration
              </li>
              <li>
                <FaCheckCircle className="icon" /> E-commerce & payment gateway integration
              </li>
              <li>
                <FaCheckCircle className="icon" /> Admin panels & content management systems
              </li>
              <li>
                <FaCheckCircle className="icon" /> App store submission & deployment support
              </li>
              <li>
                <FaCheckCircle className="icon" /> Performance optimization & security
              </li>
              <li>
                <FaCheckCircle className="icon" /> Multiple revisions to ensure satisfaction
              </li>
            </ul>
          </Col>

        </Row>
      </Container>

      {/* Pricing Section - Navy Background */}
      <div className="app-services py-5" style={{ background: "#0A184A", padding: "60px 0", borderRadius: "2rem" }}>
        <Container>
          <h2 className="text-center mb-5" style={{ color: "#ffffff", fontSize: "3rem", fontWeight: "bold" }}>
            Affordable App Development Plans
          </h2>
          <p className="text-center text-white" style={{ marginTop: "-2rem", marginBottom: "2rem" }}>
            Choose a plan that fits your app development needs. From simple apps to fully-featured platforms, our pricing is transparent and designed to deliver high-quality results.
          </p>
          <Row className="justify-content-center">

            {/* Basic Plan */}
            <Col lg={4} md={6} sm={12} className="mb-4">
              <div style={{ background: "#fff", borderRadius: "12px", padding: "30px 25px", boxShadow: "0px 6px 20px rgba(0,0,0,0.1)", textAlign: "center", border: "1px solid #eee" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <h4 style={{ fontWeight: "700", color: "#000", fontSize: "2rem" }}>Basic</h4>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <span style={{ fontSize: "2rem", fontWeight: "800", color: "#000" }}>$199.99</span>
                    <span style={{ marginTop: "-7px", marginLeft: "4rem", textDecoration: "line-through", textDecorationColor: "red", color: "red", fontSize: "1.5rem", fontWeight: "bold" }}>$249</span>
                  </div>
                </div>

                {/* Features */}
               <ul style={{ listStyle: "none", padding: 0, marginBottom: "20px", textAlign: "left" }}>
                    <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}>
                        <FaCheckCircle style={{ marginRight: "8px", color: "black" }} />Up to 5 Screens/Pages
                    </li>
                    <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}>
                        <FaCheckCircle style={{ marginRight: "8px", color: "black" }} />Basic UI/UX Design
                    </li>
                    <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}>
                        <FaCheckCircle style={{ marginRight: "8px", color: "black" }} />Basic Backend Integration
                    </li>
                    <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}>
                        <FaCheckCircle style={{ marginRight: "8px", color: "black" }} />1 Week Delivery
                    </li>
                    <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}>
                        <FaCheckCircle style={{ marginRight: "8px", color: "black" }} />100% Satisfaction Guarantee
                    </li>
                    <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}>
                        <FaCheckCircle style={{ marginRight: "8px", color: "black" }} />Support for Single Platform (iOS or Android)
                    </li>
                </ul>

                <p style={{ fontSize: "0.9rem", color: "#000", marginBottom: "20px", fontWeight: "500" }}>
                  Ideal for startups or simple app projects.
                </p>

                 <div className="buttonss-container-1" style={{ marginLeft: "-0.5rem" }}>
                  <span className="mass">Avail Now</span>
                  <Link as={Link} to="/Contact_Us" style={{ textDecoration: "none" }}>  <button  id="work" type="button"  name="Hover" style={{  background: "linear-gradient(45deg, #002266, #000436)",  color: "white", borderRadius: "9px",  border: "none", cursor: "pointer", height: "5rem" , width: "10rem"  }}>
                    Avail Now
                  </button></Link>
                </div>
              </div>
            </Col>

            {/* Standard Plan */}
            <Col lg={4} md={6} sm={12} className="mb-4">
              <div style={{ background: "#fff", borderRadius: "12px", padding: "30px 25px", boxShadow: "0px 6px 20px rgba(0,0,0,0.1)", textAlign: "center", border: "1px solid #eee" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <h4 style={{ fontWeight: "700", color: "#000", fontSize: "2rem" }}>Standard</h4>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <span style={{ fontSize: "2rem", fontWeight: "800", color: "#000" }}>$399.99</span>
                    <span style={{ marginTop: "-7px", marginLeft: "4rem", textDecoration: "line-through", textDecorationColor: "red", color: "red", fontSize: "1.5rem", fontWeight: "bold" }}>$499</span>
                  </div>
                </div>

                {/* Features */}
                <ul style={{ listStyle: "none", padding: 0, marginBottom: "20px", textAlign: "left" }}>
                  <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}><FaCheckCircle style={{ marginRight: "8px", color: "black" }} />Up to 10 Screens/Pages</li>
                  <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}><FaCheckCircle style={{ marginRight: "8px", color: "black" }} />Advanced UI/UX Design</li>
                  <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}><FaCheckCircle style={{ marginRight: "8px", color: "black" }} />API & Database Integration</li>
                  <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}><FaCheckCircle style={{ marginRight: "8px", color: "black" }} />Push Notifications & Analytics</li>
                  <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}><FaCheckCircle style={{ marginRight: "8px", color: "black" }} />2 Weeks Delivery</li>
                  <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}><FaCheckCircle style={{ marginRight: "8px", color: "black" }} />100% Satisfaction Guarantee</li>
                </ul>

                <p style={{ fontSize: "0.9rem", color: "#000", marginBottom: "20px", fontWeight: "500" }}>
                  Best for growing businesses needing a robust app.
                </p>

                  <div className="buttonss-container-1" style={{ marginLeft: "-0.5rem" }}>
                  <span className="mass">Avail Now</span>
                  <Link as={Link} to="/Contact_Us" style={{ textDecoration: "none" }}>  <button  id="work" type="button"  name="Hover" style={{  background: "linear-gradient(45deg, #002266, #000436)",  color: "white", borderRadius: "9px",  border: "none", cursor: "pointer", height: "5rem" , width: "10rem"  }}>
                    Avail Now
                  </button></Link>
                </div>
              </div>
            </Col>

            {/* Premium Plan */}
            <Col lg={4} md={6} sm={12} className="mb-4">
              <div style={{ background: "#fff", borderRadius: "12px", padding: "30px 25px", boxShadow: "0px 6px 20px rgba(0,0,0,0.1)", textAlign: "center", border: "1px solid #eee" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <h4 style={{ fontWeight: "700", color: "#000", fontSize: "2rem" }}>Premium</h4>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <span style={{ fontSize: "2rem", fontWeight: "800", color: "#000" }}>$699.99</span>
                    <span style={{ marginTop: "-7px", marginLeft: "4rem", textDecoration: "line-through", textDecorationColor: "red", color: "red", fontSize: "1.5rem", fontWeight: "bold" }}>$899</span>
                  </div>
                </div>

                {/* Features */}
                <ul   className="custom-scroll" style={{ listStyle: "none", padding: 0, marginBottom: "20px", textAlign: "left", overflowY: "auto" }}>
                  <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}><FaCheckCircle style={{ marginRight: "8px", color: "black" }} />Unlimited Screens/Pages</li>
                  <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}><FaCheckCircle style={{ marginRight: "8px", color: "black" }} />Custom Features & Integrations</li>
                  <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}><FaCheckCircle style={{ marginRight: "8px", color: "black" }} />E-commerce & Payment Gateways</li>
                  <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}><FaCheckCircle style={{ marginRight: "8px", color: "black" }} />Premium Performance & Security Optimization</li>
                  <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}><FaCheckCircle style={{ marginRight: "8px", color: "black" }} />App Store & Play Store Deployment</li>
                  <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}><FaCheckCircle style={{ marginRight: "8px", color: "black" }} />4 Weeks Delivery</li>
                  <li style={{ marginBottom: "10px", fontSize: "0.95rem", color: "#000" }}><FaCheckCircle style={{ marginRight: "8px", color: "black" }} />100% Satisfaction Guarantee</li>
                </ul>

                <p style={{ fontSize: "0.9rem", color: "#000", marginBottom: "20px", fontWeight: "500" }}>
                  Best for established businesses or complex app projects.
                </p>

                 <div className="buttonss-container-1" style={{ marginLeft: "-0.5rem" }}>
                  <span className="mass">Avail Now</span>
                  <Link as={Link} to="/Contact_Us" style={{ textDecoration: "none" }}>  <button  id="work" type="button"  name="Hover" style={{  background: "linear-gradient(45deg, #002266, #000436)",  color: "white", borderRadius: "9px",  border: "none", cursor: "pointer", height: "5rem" , width: "10rem"  }}>
                    Avail Now
                  </button></Link>
                </div>
              </div>
            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
};

export default App_Services;
